import { render, staticRenderFns } from "./ClassLearningProgress.vue?vue&type=template&id=3bbaacfa&scoped=true&lang=pug&"
import script from "./ClassLearningProgress.vue?vue&type=script&lang=ts&"
export * from "./ClassLearningProgress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbaacfa",
  null
  
)

export default component.exports